import React from 'react';
import { useTheme } from '../App';
import '../styles/Collab.css';

const collabs = [
  { name: 'Board Game Cafe', logo: '/images/collab/boardgamecafe.png' },
  { name: 'GOH', logo: '/images/collab/GOH.png' },
  { name: 'KU Play', logo: '/images/collab/KUPLAYCIRCLELOGO.png' },
  {
    name: 'Meja Belakang',
    logo: '/images/collab/mejabelakangwhite.png',
    lightLogo: '/images/collab/mejabelakangwhite-light-mode.png'
  },
  {
    name: 'UTB',
    logo: '/images/collab/utbwhite.png',
    lightLogo: '/images/collab/utbwhite-light-mode.png'
  },
  {
    name: 'Zodiac GO',
    logo: '/images/collab/zodiacgo.png',
    lightLogo: '/images/collab/zodiacgo-light-mode.png'
  },
  {
    name: 'CopHunt',
    logo: '/images/collab/cophunt.svg',
    lightLogo: '/images/collab/cophunt-light-mode.svg',
    href: 'https://cophunt.com'
  },
];

const Collab = () => {
  const { darkMode } = useTheme();
  return (
    <section className="collab-section">
      <div className="collab-header">
        <h2 className="collab-title">
          <span className="title-text">OUR COLLABORATORS</span>
          <span className="title-burst">!</span>
        </h2>
        <p className="collab-subtitle">
          Proud to partner with these amazing brands
        </p>
      </div>

      <div className="collab-grid">
        {collabs.map((collab, index) => {
          const logo = (
            <div className="collab-logo-wrapper">
              <img
                src={!darkMode && collab.lightLogo ? collab.lightLogo : collab.logo}
                alt={collab.name}
                className="collab-logo"
              />
            </div>
          );
          return (
            <div key={index} className="collab-item">
              {collab.href ? (
                <a
                  href={collab.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={collab.name}
                >
                  {logo}
                </a>
              ) : (
                logo
              )}
            </div>
          );
        })}
      </div>

      <div className="collab-decoration">
        <div className="speed-lines"></div>
      </div>
    </section>
  );
};

export default Collab;
